/** @jsxImportSource theme-ui */
import PropTypes from "prop-types";
import { colors, typography } from "../../styles/theme";
import Icon from "./Icon";
import { Text } from "theme-ui";

const tagStyle = {
  ...typography.textMd500,
  color: colors.black,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.313rem 0.938rem",
  borderRadius: "100px",
  width: "fit-content",
};

const Tag = ({ label, bgColor, leftIconName, rightIconName, customStyles }) => {

  const bgColorStyles = bgColor.startsWith("#") ? { backgroundColor: bgColor } : getBgColorStyles(bgColor);
  
  return (
    <div
      sx={{ ...tagStyle, ...bgColorStyles, ...customStyles }}
    >
      {leftIconName && (
        <Icon
          name={leftIconName}
          color={colors.black}
          customStyles={{ marginRight: "0.25rem" }}
          size={20}
        />
      )}
      <Text sx={{ textAlign: "center" }}>{label}</Text>
      {rightIconName && (
        <Icon
          name={rightIconName}
          color={colors.black}
          customStyles={{ marginLeft: "0.25rem" }}
          size={20}
        />
      )}
    </div>
  );
};

const getBgColorStyles = (bgColor) => {
  switch (bgColor) {
    case "orange400":
      return { backgroundColor: colors.secondaryOrange400 };
    case "orange":
      return { backgroundColor: colors.secondaryOrange200 };
    case "blue":
      return { backgroundColor: colors.secondaryBlue200 };
    case "green":
      return { backgroundColor: colors.secondaryGreen200 };
    default:
      return {};
  }
};

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  leftIconName: PropTypes.string,
  rightIconName: PropTypes.string,
  customStyles: PropTypes.object,
};

Tag.defaultProps = {
  bgColor: "green",
  customStyles: {},
};

export default Tag;
